import { airtableClient } from "./airtableClient";
// todo add this to env
export const wfhRulesDb = airtableClient.base("apphFzWJOxATlXOo6");
